export const black = '#1A1919'
export const grey = '#B4B2AB'
export const lightGrey = '#cccccc'
export const red = '#BE7474'
export const border = '#C3C3C3'